import React, {useContext, useMemo} from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog, faExclamation} from "@fortawesome/free-solid-svg-icons";
import {GlobalContext} from "../../contexts/global.js";

// Style
import {z} from "../../style/components/mixins.js";
import {colors, pad} from "../../style/components/variables.js";
import {Abbr, Button} from "../../style/components/general.js";

// Socket Constants
import Badge from "../../components/Badge.js";

const TableFacilitiesFacilitySettings = ({facility, setTarget, setShowModalSettings}) => {
  const {id} = facility;

  const {deletingFacilities} = useContext(GlobalContext);

  const deleting = useMemo(() => deletingFacilities[id] === false, [deletingFacilities, id]);

  return (
    <Settings
      type="button"
      title="Facility Settings"
      disabled={deleting}
      onClick={
        deleting
          ? undefined
          : () => {
              setTarget(facility);
              setShowModalSettings(true);
            }
      }>
      {!facility.hasNotifications && (
        <Badge offsetX="7px" offsetY="8px" color={colors.red} diameter="16px">
          <StyledAbbr title="Notifications not configured">
            <FontAwesomeIcon icon={faExclamation} />
          </StyledAbbr>
        </Badge>
      )}
      <FontAwesomeIcon icon={faCog} className="primaryIcon">
        Settings
      </FontAwesomeIcon>
    </Settings>
  );
};

TableFacilitiesFacilitySettings.propTypes = {
  facility: PropTypes.objectOf(PropTypes.any).isRequired,
  setTarget: PropTypes.func.isRequired,
  setShowModalSettings: PropTypes.func.isRequired
};

// Style Overrides
const Settings = styled(Button)`
  position: absolute;
  top: 0;
  left: 0;
  padding: ${pad}px ${pad}px ${pad / 2}px;
  background: transparent;
  z-index: ${z("top")};

  .primaryIcon {
    fill: ${({theme}) => theme.secondary};
  }
`;

const StyledAbbr = styled(Abbr)`
  padding-left: 0.55px;
`;

export default TableFacilitiesFacilitySettings;
